import { baseRoutes } from "helpers/baseRoutes";

/**
 * Define access routes for the dashboard, specifying the path and icon using baseRoutes from the "helpers/baseRoutes" module.
 * @constant {Object} accessRoute
 */
const accessRoute = {
  USER_REQUEST: {
    path: `${baseRoutes.instructorBaseRoutes}/user-request`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-user-list" />
      </span>
    ),
  },
  USER_CALORIE_LOGS_INSTRUCTOR: {
    path: `${baseRoutes.instructorBaseRoutes}/user-calorie-logs`,
  },
  USER_ACCEPTED_REQUEST: {
    path: `${baseRoutes.instructorBaseRoutes}/accepted-request`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon ni ni-users" />
      </span>
    ),
  },
};

export default accessRoute;
